import { connect } from 'react-redux';
import {
  getAllQuote,
  getFranchise,
  getCommercialCustomerList,
  deleteCommercialCustomer,
  getResourceList,
  addResource,
  updateResource,
  deleteResource,
  getKanbanList,
  getCommercialProposal,
  addPWSInstall, updatePWSInstall
} from '../../../../Action';
import List from "../Component/List";

const mapStateToProps = (state) => {
  const {Settings, CommercialProposal, CommercialCustomer, Resource, CommercialKanban} = state;

  return {
    Settings, CommercialProposal, CommercialCustomer, Resource, CommercialKanban
  }
}

const actionCreators = {
  getFranchise,
  getAllQuote,
  getCommercialCustomerList, deleteCommercialCustomer,
  getResourceList, addResource, updateResource, deleteResource,
  getKanbanList, addPWSInstall, updatePWSInstall,
  getCommercialProposal
}
export default (connect(mapStateToProps, actionCreators)(List));